module.exports = __webpack_public_path__ + "img/gateway-red.0c260ed6.png";